import { PageTypeId } from '../const';
import { NavigationModuleSchema } from '../types';
import { navigationCodes } from '../../../data/translations/navigationCodes';

export const defaultUserNavigationSchema: NavigationModuleSchema = [
	{
		titleCode: navigationCodes.general,
		pageTypeId: PageTypeId.Dashboard,
		childrenPageTypeIds: [PageTypeId.ManagementInformation],
	},
	{
		titleCode: navigationCodes.agency,
		pageTypeId: PageTypeId.AgencyList,
		childrenPageTypeIds: [PageTypeId.AgencyStructure],
	},
	{
		titleCode: navigationCodes.employer,
		pageTypeId: PageTypeId.EmployerList,
		childrenPageTypeIds: [
			PageTypeId.EmployerContactPersonsList,
			PageTypeId.DealList,
			PageTypeId.SupplierOrganizationList,
		],
	},
	{
		titleCode: navigationCodes.candidate,
		pageTypeId: PageTypeId.CandidateList,
		childrenPageTypeIds: [
			PageTypeId.CandidateChangeList,
			PageTypeId.CandidatePeriodicComponentsList,
			PageTypeId.CandidateCandidateStatusMapping,
			PageTypeId.ProformaList,
		],
	},
	{
		titleCode: navigationCodes.contract,
		pageTypeId: PageTypeId.ContractList,
		childrenPageTypeIds: [PageTypeId.ContractBulkUpdateRequestList],
	},
	{
		titleCode: navigationCodes.document,
		pageTypeId: PageTypeId.DocumentList,
		childrenPageTypeIds: [PageTypeId.DocumentSettingsList],
	},
	{
		titleCode: navigationCodes.timecard,
		pageTypeId: PageTypeId.TimecardList,
	},
	{
		titleCode: navigationCodes.invoice,
		pageTypeId: PageTypeId.InvoiceList,
		childrenPageTypeIds: [PageTypeId.InvoicePurchaseInvoice],
	},
	{
		titleCode: navigationCodes.backoffice,
		pageTypeId: PageTypeId.BackofficeIndex,
		childrenPageTypeIds: [PageTypeId.BackofficeProcessingList],
	},
	{
		titleCode: navigationCodes.backofficeTransferfiles,
		pageTypeId: PageTypeId.BackofficeJournalTransferFilesList,
		childrenPageTypeIds: [PageTypeId.BackofficePaymentTransferFilesList],
	},
	{
		titleCode: navigationCodes.payslip,
		pageTypeId: PageTypeId.PayslipList,
	},
	{
		titleCode: navigationCodes.candidatePhase,
		pageTypeId: PageTypeId.CandidatePhaseList,
	},
	{
		titleCode: navigationCodes.pension,
		pageTypeId: PageTypeId.PensionList,
	},
	{
		titleCode: navigationCodes.illness,
		pageTypeId: PageTypeId.IllnessList,
	},
	{
		titleCode: navigationCodes.candidateReservation,
		pageTypeId: PageTypeId.CandidateReservationList,
	},
	{
		titleCode: navigationCodes.payment,
		pageTypeId: PageTypeId.PaymentList,
	},
	{
		titleCode: navigationCodes.newsList,
		pageTypeId: PageTypeId.NewsList,
		childrenPageTypeIds: [PageTypeId.CommentList, PageTypeId.CommunitiesList],
	},
	{
		titleCode: navigationCodes.job,
		pageTypeId: PageTypeId.JobList,
	},
	{
		titleCode: navigationCodes.workflow,
		pageTypeId: PageTypeId.TaskList,
		childrenPageTypeIds: [PageTypeId.ActivityList],
	},
	{
		titleCode: navigationCodes.caowijzer,
		pageTypeId: PageTypeId.CaoNewsList,
		childrenPageTypeIds: [
			PageTypeId.CaoList,
			PageTypeId.CaoInstanceList,
			PageTypeId.CaoWagesList,
			PageTypeId.CaoWagesRequestsList,
			PageTypeId.CaoWmlList,
		],
	},
	{
		titleCode: navigationCodes.application,
		pageTypeId: PageTypeId.ApplicationList,
		childrenPageTypeIds: [PageTypeId.ApplicationForm],
	},
	{
		titleCode: navigationCodes.share,
		pageTypeId: PageTypeId.ShareJobBoardInstanceList,
		childrenPageTypeIds: [PageTypeId.ShareJobBoardList, PageTypeId.ShareJobPostList, PageTypeId.ShareLogList],
	},
	{
		titleCode: navigationCodes.survey,
		pageTypeId: PageTypeId.SurveyList,
	},
	{
		titleCode: navigationCodes.form,
		pageTypeId: PageTypeId.FormUserList,
	},
	{
		titleCode: navigationCodes.safety,
		pageTypeId: PageTypeId.SafetyList,
	},
];

export const defaultAdminNavigationSchema: NavigationModuleSchema = [
	{
		titleCode: navigationCodes.user,
		pageTypeId: PageTypeId.UserList,
		childrenPageTypeIds: [PageTypeId.SubscriberList],
	},
	{
		titleCode: navigationCodes.role,
		pageTypeId: PageTypeId.RoleList,
	},
	{
		titleCode: navigationCodes.connect,
		pageTypeId: PageTypeId.ConnectIncomingList,
		childrenPageTypeIds: [
			PageTypeId.ConnectIncomingLogList,
			PageTypeId.ConnectOutgoingList,
			PageTypeId.ConnectOutgoingLogList,
			PageTypeId.ConnectSettings,
			PageTypeId.ConnectEmailSenderAuthList,
			PageTypeId.ConnectApiUserList,
			PageTypeId.ConnectorList,
			PageTypeId.ConnectCustomerAccessRequestList,
			PageTypeId.ConnectFSApiLogList,
			PageTypeId.ConnectDashboard,
		],
	},
	{
		titleCode: navigationCodes.customer,
		pageTypeId: PageTypeId.CustomerList,
		childrenPageTypeIds: [
			PageTypeId.InvoiceComponentsList,
			PageTypeId.CustomerInvoiceList,
			PageTypeId.CustomerSubscriptionList,
			PageTypeId.CustomerSubscriptionSettingList,
		],
	},
	{
		titleCode: navigationCodes.label,
		pageTypeId: PageTypeId.LabelList,
		childrenPageTypeIds: [PageTypeId.LabelTranslations, PageTypeId.LabelTemplates, PageTypeId.LabelPagesList],
	},
	{
		titleCode: navigationCodes.tag,
		pageTypeId: PageTypeId.TagList,
	},
	{
		titleCode: navigationCodes.newsAdmin,
		pageTypeId: PageTypeId.NewsAdminList,
	},
	{
		titleCode: navigationCodes.savedFilter,
		pageTypeId: PageTypeId.SavedFilterMyFiltersList,
		childrenPageTypeIds: [
			PageTypeId.SavedFilterSystemFiltersList,
			PageTypeId.SavedFilterOtherUsersFiltersList,
			PageTypeId.SavedFilterAlertLogsList,
		],
	},
	{
		titleCode: navigationCodes.rateClasses,
		pageTypeId: PageTypeId.RateClassesList,
	},
	{
		titleCode: navigationCodes.calculationScheme,
		pageTypeId: PageTypeId.CalculationSchemeList,
	},
	{
		titleCode: navigationCodes.domainValues,
		pageTypeId: PageTypeId.DomainValuesList,
		childrenPageTypeIds: [PageTypeId.DomainValuesMapping, PageTypeId.DomainValuesCAOMapping],
	},
	{
		titleCode: navigationCodes.modelMatrix,
		pageTypeId: PageTypeId.ModelMatrixList,
		childrenPageTypeIds: [PageTypeId.ModelMatrixInstanceList],
	},
	{
		titleCode: navigationCodes.componentModel,
		pageTypeId: PageTypeId.ComponentModelList,
	},
	{
		titleCode: navigationCodes.documentTemplate,
		pageTypeId: PageTypeId.DocumentTemplateList,
	},
	{
		titleCode: navigationCodes.caowijzerCustomCao,
		pageTypeId: PageTypeId.CustomCaoList,
		childrenPageTypeIds: [PageTypeId.CustomCaoInstanceList],
	},
	{
		titleCode: navigationCodes.textModel,
		pageTypeId: PageTypeId.TextModelList,
	},
	{
		titleCode: navigationCodes.auditTrail,
		pageTypeId: PageTypeId.AuditTrailList,
		childrenPageTypeIds: [PageTypeId.SettingList],
	},
	{
		titleCode: navigationCodes.survey,
		pageTypeId: PageTypeId.SurveyAdminList,
		childrenPageTypeIds: [PageTypeId.SurveyListOptOutList],
	},
	{
		titleCode: navigationCodes.flexNetBundle,
		pageTypeId: PageTypeId.FlexNetBundleList,
		childrenPageTypeIds: [
			PageTypeId.FlexNetHostList,
			PageTypeId.FlexNetCustomerList,
			PageTypeId.FlexNetHostSettings,
		],
	},
	{
		titleCode: navigationCodes.formDesigner,
		pageTypeId: PageTypeId.FormDesignerList,
	},
	{
		titleCode: navigationCodes.automation,
		pageTypeId: PageTypeId.AutomationList,
		childrenPageTypeIds: [PageTypeId.AutomationLogList],
	},
];

export const defaultSupportNavigationSchema: NavigationModuleSchema = [
	{
		titleCode: navigationCodes.help,
		pageTypeId: PageTypeId.Help,
	},
	{
		titleCode: navigationCodes.learnings,
		pageTypeId: PageTypeId.Faq,
	},
];

export const defaultFooterNavigationSchema: NavigationModuleSchema = [
	{ titleCode: navigationCodes.aboutUs, pageTypeId: PageTypeId.AboutUs },
	{ titleCode: navigationCodes.contactUs, pageTypeId: PageTypeId.ContactUs },
	{ titleCode: navigationCodes.cvdPolicy, pageTypeId: PageTypeId.CvdPolicy },
	{ titleCode: navigationCodes.privacyStatement, pageTypeId: PageTypeId.PrivacyStatement },
	{ titleCode: navigationCodes.securityStatement, pageTypeId: PageTypeId.SecurityStatement },
	{ titleCode: navigationCodes.termsOfUse, pageTypeId: PageTypeId.TermsOfUse },
];
